import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import WorkRoundedIcon from '@mui/icons-material/WorkRounded';
import SchoolRoundedIcon from '@mui/icons-material/SchoolRounded';
import CampaignRoundedIcon from '@mui/icons-material/CampaignRounded';
import CodeRoundedIcon from '@mui/icons-material/CodeRounded';
import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded';
import EmojiEventsRoundedIcon from '@mui/icons-material/EmojiEventsRounded';
import {useTheme} from "@mui/material/styles";

const items = [
    { icon: <WorkRoundedIcon />, value: '6+ years', title: 'Experience', desc: 'Building production Java systems', grad: 'linear-gradient(135deg, #2563EB, #60A5FA)' },
    { icon: <GroupsRoundedIcon />, value: '10+ engineers', title: 'Leadership', desc: 'Managing and mentoring teams', grad: 'linear-gradient(135deg, #7C3AED, #A78BFA)' },
    { icon: <CampaignRoundedIcon />, value: '8+ events', title: 'Conferences', desc: 'Expert and speaker at major conferences (Joker, Jpoint, Стачка).', grad: 'linear-gradient(135deg, #059669, #34D399)' },
    { icon: <SchoolRoundedIcon />, value: '3 years', title: 'Teaching', desc: 'University lecturer', grad: 'linear-gradient(135deg, #DC2626, #F87171)' },
    { icon: <CodeRoundedIcon />, value: '99.999%', title: 'System Reliability', desc: 'Designing architectures with extremely high levels of fault tolerance.', grad: 'linear-gradient(135deg, #D97706, #FBBF24)' },
    { icon: <EmojiEventsRoundedIcon />, value: '1 billion', title: 'Daily Events', desc: 'Systems designed & built by me', grad: 'linear-gradient(135deg, #0891B2, #22D3EE)' },
];



const HighlightsSection: React.FC = () => {
    const theme = useTheme();
    const dark = theme.palette.mode === 'dark';
    return <Box sx={{py: {xs: 6, md: 10}}}>
        <Box sx={{ position: 'absolute', bottom: -200, right: -200, width: 600, height: 600, borderRadius: '50%', background: dark ? 'radial-gradient(circle, rgba(124,58,237,0.06) 0%, transparent 70%)' : 'radial-gradient(circle, rgba(124,58,237,0.09) 0%, transparent 70%)', pointerEvents: 'none' }} />

        <Container maxWidth="lg">
            <Typography variant="h3" sx={{fontSize: {xs: '1.8rem', md: '2.2rem'}, mb: 1, textAlign: 'center'}}>At a
                Glance</Typography>
            <Typography variant="body1" color="text.secondary"
                        sx={{mb: 6, textAlign: 'center', maxWidth: 500, mx: 'auto'}}>Key highlights from my
                career</Typography>
            <Grid container spacing={3}>
                {items.map(item => (
                    <Grid item xs={12} sm={6} md={4} key={item.title}>
                        <Card sx={{height: '100%', '&:hover': {transform: 'translateY(-4px)'}, transition: 'all 0.3s'}}>
                            <CardContent sx={{p: 3.5}}>
                                <Box sx={{
                                    width: 52,
                                    height: 52,
                                    borderRadius: '14px',
                                    background: item.grad,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    mb: 2.5,
                                    color: '#fff',
                                    '& svg': {fontSize: 26}
                                }}>
                                    {item.icon}
                                </Box>
                                <Typography variant="h3" sx={{
                                    fontSize: '1.8rem',
                                    mb: 0.5,
                                    background: item.grad,
                                    backgroundClip: 'text',
                                    WebkitBackgroundClip: 'text',
                                    WebkitTextFillColor: 'transparent'
                                }}>{item.value}</Typography>
                                <Typography variant="subtitle1"
                                            sx={{fontWeight: 600, mb: 0.5}}>{item.title}</Typography>
                                <Typography variant="body2" color="text.secondary">{item.desc}</Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Container>
    </Box>
};

export default HighlightsSection;
